module.exports = __webpack_public_path__ + "img/open-btn-bg2-D3rUtn-q.2597cbde.png";